import { ThreadListItemPrimitive } from '@assistant-ui/react';
import { IconArchive } from '@tabler/icons-react';

import { TooltipIconButton } from '../tooltip-icon-button/TooltipIconButton.tsx';

/** Archive button for thread list items. Uses assistant-ui's primitive to handle archive action. */
export function ThreadListItemArchive() {
  return (
    <ThreadListItemPrimitive.Archive asChild>
      <TooltipIconButton tooltip="Archive thread" variant="subtle">
        <IconArchive color="var(--mantine-color-dark-1)" size={16} />
      </TooltipIconButton>
    </ThreadListItemPrimitive.Archive>
  );
}
